import axios from 'axios';
import { getHostname } from '../../../utils/hostname';

// Ten sam endpoint co formularz kontaktowy „Majątkowe” (LuxmedForm):
// reCAPTCHA v3 z akcją submitForm, dane lecą do skryptu SubmitFormScript.
// `subject` to przyszłościowo: skrypt dziś ma temat na sztywno
// („Zgłoszenie - majątkowe”), po patchu może użyć context.subject.
export async function submitLead(
  executeRecaptcha,
  { fullName, phone, email, message, subject }
) {
  if (!executeRecaptcha) {
    throw new Error('reCAPTCHA not ready');
  }
  const captchaToken = await executeRecaptcha('submitForm');
  return axios.post('/ws/luxmedpublic/SubmitForm', {
    fullName,
    phone,
    email: email || '',
    message,
    subject,
    siteSource: getHostname(),
    'g-recaptcha-response': captchaToken
  });
}
